$(function () {
   const linkSelector = `a[href='${window.theme.custom.links.pages.worldwide}']`;
   $(linkSelector).attr('href', window.theme.custom.links.pages.worldwide + "?from=" + encodeURIComponent(windowHref));

   $(".sk-worldwide .p-main .link--animated").click(function (e) {
      e.preventDefault();

      const countrySelected = $(this).data('country');
      const worldWideURL = $(this).attr("href");

      switch (countrySelected) {
         case 'canada':
         case 'united-states':
            const worldwideURLParams = allUrlParams.get('from');

            if (worldwideURLParams) {
               // US/Canada will stay on the current site and link to the page the user came from
               window.location = decodeURIComponent(worldwideURLParams);
            } else {
               window.location = "/";
            }
            break;
         default:
            window.location = worldWideURL;
      }
   })
});